import React, {FC, useState} from 'react'
import {Form, Formik} from 'formik'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {updateCustomer, createCustomer} from './Api'
import {
  initialServiceStation,
  IServiceStationModel,
  serviceStationTabs,
  serviceStationToCustomerPayload,
  validationServiceStation,
} from './ServiceStationModel'
import { 
  COUNTRY_OPTIONS,
  RISK_TYPES, 
} from '../../../shared/models/SharedConstantLookups'
import SelectInput from '../../../shared/components/SelectInput'
import {showErrorToast, showSuccessToast} from '../../../shared/components/ToastUtils'
import FormTabHeader from '../../../shared/components/FormTabHeader'
import TextInput from '../../../shared/components/TextInput'
import PhoneInput from '../../../shared/components/PhoneInput'
import CheckboxInput from '../../../shared/components/CheckboxInput'
import TextAreaInput from '../../../shared/components/TextAreaInput' 

export const ServiceStationPage: FC = () => {
  const [tab, setTab] = useState<string>('company')
  const [loading, setLoading] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null | undefined>(null)  
 

  const handleSave = async (values: IServiceStationModel, resetForm: () => void) => {
    setLoading(true)
    try {
      const payload = serviceStationToCustomerPayload(values)
      if (selectedId) {
        await updateCustomer({...payload, id: selectedId, customerType: 'SERVICE'})
        showSuccessToast('Müşteri başarıyla güncellendi')
      } else {
        await createCustomer({...payload, customerType: 'SERVICE'})
        showSuccessToast('Müşteri başarıyla oluşturuldu')
      }
      resetForm()
      setSelectedId(null)
    } catch (err) {
      showErrorToast('Bir hata oluştu')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Formik
        initialValues={initialServiceStation}
        validationSchema={validationServiceStation}
        enableReinitialize
        onSubmit={(values, {resetForm}) => handleSave(values, resetForm)}
      >
        {(formik) => {
          const handleReset = () => {
            formik.resetForm()
            setSelectedId(null)
          }
          return (
            <>
              <FormTabHeader
                formId='ServiceStationForm'
                formikSubmit={formik.handleSubmit}
                formikReset={handleReset}
                loading={loading}
                tab={tab}
                setTab={setTab}
                setSelectedId={setSelectedId}
                tabs={serviceStationTabs}
                onExportExcel={() => console.log('Excel export')}
              />    
              <div className='card mb-5'>
                <Form id='ServiceStationForm' className='form card-body'>
                  {/* ── Tab 1: Firma Bilgileri ── */}
                  {tab === 'company' && (
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='row g-4'>
                          <TextInput
                            labelPosition='top'
                            name='firstName'
                            label='Firma Adı'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='lastName'
                            label='Devamı'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='taxOffice'
                            label='Vergi Dairesi'
                            wrapperClassName='col-6'
                          />
                          <TextInput
                            labelPosition='top'
                            name='taxNumber'
                            type='number'
                            label='Vergi Numarası'
                            wrapperClassName='col-6'
                          />
                          <TextInput
                            labelPosition='top'
                            max={11}
                            type='number'
                            name='tcKimlikNo'
                            label='TC Kimlik No'
                            wrapperClassName='col-12'
                          />
                          <SelectInput
                            labelPosition='top'
                            name='country'
                            label='Ülke'
                            wrapperClassName='col-12'
                            options={COUNTRY_OPTIONS}
                          />
                          <TextInput
                            labelPosition='top'
                            name='city'
                            label='Şehir'
                            wrapperClassName='col-6'
                          />
                          <TextInput
                            labelPosition='top'
                            name='district'
                            label='İlçe'
                            wrapperClassName='col-6'
                          />
                          <PhoneInput name='gsm1' label='Gsm' wrapperClassName='col-6' />
                          <PhoneInput name='gsm2' label='Gsm2' wrapperClassName='col-6' />
                          <PhoneInput name='phone' label='Telefon' wrapperClassName='col-6' />
                          <TextInput
                            labelPosition='top'
                            name='emailAddress'
                            label='Mail Adresi'
                            wrapperClassName='col-6'
                          />
                          
                          <TextAreaInput
                            labelPosition='top'
                            name='address'
                            label='Adres'
                            rows={3}
                            wrapperClassName='col-12'
                          /> 
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <div className='row g-4'> 
                          <TextInput
                            labelPosition='top' 
                            name='specialCode'
                            label='Özel Kod'
                            wrapperClassName='col-6'
                          />
                          <TextInput
                            labelPosition='top'
                            name='integrationCode'
                            label='Entegrasyon Kodu'
                            wrapperClassName='col-6'
                          />
                          <TextInput
                            labelPosition='top'
                            name='riskMessage'
                            label='Risk Mesajı'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='riskMessageDate'
                            type='date'
                            label='Risk Mesajı Tarihi'
                            wrapperClassName='col-12'
                          />
                          <SelectInput
                            labelPosition='top'
                            name='riskPermit'
                            label='Risk İzinli'
                            wrapperClassName='col-12'
                            options={RISK_TYPES}
                          />
                          <TextInput
                            labelPosition='top'
                            name='dealerCommissionRate'
                            type='number'
                            label='Bayi Komisyon Oranı'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='partsDiscount'
                            type='number'
                            label='Parça İndirim'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='laborDiscount'
                            type='number'
                            label='İşçilik İndirim'
                            wrapperClassName='col-12'
                          />
                          <TextInput
                            labelPosition='top'
                            name='consumablesDiscount'
                            type='number'
                            label='Sarf Malzeme İndirim'
                            wrapperClassName='col-12'
                          />
                            <TextAreaInput
                            labelPosition='top'
                            name='description'
                            label='Açıklama'
                            rows={3}
                            wrapperClassName='col-12'
                          />
                        </div>
                      </div>
                    </div>
                  )} 
                  {/* ── Tab 3: İzinler & Ayarlar ── */}
                  {tab === 'permission' && (
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='row g-4'>
                          <CheckboxInput
                            name='passive'
                            label='Pasif Et'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='hideInvoiceDetail'
                            label='Fatura Detay Belirtme'
                            wrapperClassName='col-12'
                          />
                          <div className='col-12'>
                            <div className='d-flex gap-5'>
                              <CheckboxInput name='smsPermission' label='SMS İzin' />
                              <CheckboxInput name='mailPermission' label='Mail İzin' />
                              <CheckboxInput name='phonePermission' label='Telefon İzin' />
                            </div>
                          </div>
                          <CheckboxInput
                            name='birthdayTracking'
                            label='Doğum Günü Takip'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='customerCardAnonymized'
                            label='Müşteri Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                          
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <div className='row g-4'>
                        <CheckboxInput
                            name='rentalCardAnonymized'
                            label='Kira Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='reservationCardAnonymized'
                            label='Rezervasyon Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='invoiceCardAnonymized'
                            label='Fatura Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='cashboxCardAnonymized'
                            label='Banka-Kasa Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                          <CheckboxInput
                            name='trafficHgsCardAnonymized'
                            label='Trafik ve HGS Ceza Kartı Anonimleştir'
                            wrapperClassName='col-12'
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </Form>
              </div>
            </>
          )
        }}
      </Formik>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}
